import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-detail" }
const _hoisted_2 = ["src"]

import { onMounted, ref } from 'vue'
import { getStaticHtml, getOssUrls } from '@/api'
import { findSequences, findSequences2 } from '@/utils'
import router from '@/router';
import store from '@/store';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'ModelView',
  setup(__props) {

const loadUrl: any = ref({})

onMounted(async () => {
  const relatedHtmlId: any = router.currentRoute.value.query.relatedHtmlId;
  getStaticHtml({ id: relatedHtmlId }).then((html: any) => {
    const resultKeys = findSequences(html);
    const resultSources = findSequences2(html);
    getOssUrls(resultKeys).then((res: any) => {
      resultKeys.forEach((urlKey, i) => {
        html = html.replace(resultSources[i], `source src="${res[i]}`)
      });
      (document.querySelector('.news-detail .detail-html') as any).innerHTML = html
    })
  })
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body) {
    document.body.scrollTop = 0
  }

  const model_bg: any = await asynchronousRetrieval('webimg/images/solution/model-bg.png');
  loadUrl.value = { model_bg }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: loadUrl.value.model_bg
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "detail-html" }, null, -1))
  ]))
}
}

})